
<template>
  <div class="cbody1">
      
      <div class="userbody">
          <div class="left">
               <div class="box1">
                    <div class="userimg">
                      <svg data-bbox="0 0 50 50" data-type="shape" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 50 50"><g><path d="M25 48.077c-5.924 0-11.31-2.252-15.396-5.921 2.254-5.362 7.492-8.267 15.373-8.267 7.889 0 13.139 3.044 15.408 8.418-4.084 3.659-9.471 5.77-15.385 5.77m.278-35.3c4.927 0 8.611 3.812 8.611 8.878 0 5.21-3.875 9.456-8.611 9.456s-8.611-4.246-8.611-9.456c0-5.066 3.684-8.878 8.611-8.878M25 0C11.193 0 0 11.193 0 25c0 .915.056 1.816.152 2.705.032.295.091.581.133.873.085.589.173 1.176.298 1.751.073.338.169.665.256.997.135.515.273 1.027.439 1.529.114.342.243.675.37 1.01.18.476.369.945.577 1.406.149.331.308.657.472.98.225.446.463.883.714 1.313.182.312.365.619.56.922.272.423.56.832.856 1.237.207.284.41.568.629.841.325.408.671.796 1.02 1.182.22.244.432.494.662.728.405.415.833.801 1.265 1.186.173.154.329.325.507.475l.004-.011A24.886 24.886 0 0 0 25 50a24.881 24.881 0 0 0 16.069-5.861.126.126 0 0 1 .003.01c.172-.144.324-.309.49-.458.442-.392.88-.787 1.293-1.209.228-.232.437-.479.655-.72.352-.389.701-.78 1.028-1.191.218-.272.421-.556.627-.838.297-.405.587-.816.859-1.24a26.104 26.104 0 0 0 1.748-3.216c.208-.461.398-.93.579-1.406.127-.336.256-.669.369-1.012.167-.502.305-1.014.44-1.53.087-.332.183-.659.256-.996.126-.576.214-1.164.299-1.754.042-.292.101-.577.133-.872.095-.89.152-1.791.152-2.707C50 11.193 38.807 0 25 0"></path></g></svg>
                    </div>
                    <div class="username">
                       {{userdata.name==''?'你好': userdata.name}}
                    </div>
               </div>
               <div class="box2">
                  <router-link v-for="item in usernav" :to="item.path" :key="item.title" class="nav" >{{item.title}}</router-link>
               </div>
          </div>

          <div class="right">
                <div class="box">
                   <p class="p1">Manage Your Bookings</p>
                   <p class="p2">View, reschedule or cancel your bookings and easily book again.<br>
Time Zone: Hong Kong Standard Time (GMT+8) </p>
                 <p class="p2">♡預約日期前2～3天會收到WhatsApp溫馨提示♡</p>
                 <div class="orderbox">
                     <div class="ordernav">
                        <div :class="ifnow? 'btn1 this' : 'btn1' " @click="sc(1)">Upcoming</div>
                        <div :class="!ifnow? 'btn1 this' : 'btn1' " @click="sc(2)">History</div>
                     </div>
                     <div class="orderlist">
                       
                      <el-table
                      :data="listData"
                      
                      v-loading="isLoading"
                      style="width: 100%" v-if="!iftips">

                      <template v-slot:empty>
                    <div class="custom-empty">
                      <el-icon><Loading /></el-icon>
                      <span></span>
                    </div>
                  </template>
                      <el-table-column type="expand">
                  <template slot-scope="props">
                    <el-form label-position="left" inline class="demo-table-expand">
                      <el-form-item label="療程">
                        <span v-for="item2 in props.row.program_second" :key="item2">{{item2}}<br></span>
                      </el-form-item>
                      <el-form-item label="治療師">
                        <span>{{ props.row.user_name }}</span>
                      </el-form-item>
                      <el-form-item label="備註" v-if="isMobile">
                        <span v-if="props.row.remark">{{ props.row.remark }}</span>
                        <span v-else> </span>
                      </el-form-item>
                     
                    </el-form>
                  </template>
                </el-table-column>
        
                      <el-table-column
                       
                        prop="time"
                        label="預約日期及時間"
                       >
                        <template slot-scope="scope">
                          <div>{{scope.row.time.split(' ')[0]}}<br>{{scope.row.time.split(' ')[1]}}</div>
                         
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop="program"
                        label="項目"
                       >
   
                      </el-table-column>
      
                      <el-table-column
                        prop="remark"
                        label="備註"
                        v-if="!isMobile"
                        >
                        <template slot-scope="scope">
                        <span v-if="scope.row.remark || scope.row.remark=='null' || scope.row.remark==null">{{ scope.row.remark }}</span>
                        <span v-else> </span>
                      </template>
                      </el-table-column>
                    
                      <el-table-column
                  
                        :label="ifnow?'操作':'狀態'"
                        >
                        <template slot-scope="scope">
                   
                          <el-button type="text" size="small" @click="gotos(scope.row)" v-if="ifnow">改期</el-button>
                          <el-button type="text" size="small" @click="qx(scope.row)" v-if="ifnow">取消</el-button>

                          <el-tag
                          size="small"
                          v-if="!ifnow"
                    
                          :type="scope.row.status==2?'success':'danger'"
                          effect="dark">
                          {{ scope.row.status==2?'完成':'取消/過期' }}
                        </el-tag>
                        </template>
                      </el-table-column>
                    </el-table>
                    <el-pagination
                      small
                      layout="prev, pager, next"
                      :total="total"
                      :page-size="params.limit"
                      @current-change="handleCurrentChange"

                      style="text-align:center"
                      >
                    </el-pagination>
                      <div class="tips" @click="gowhats()" v-if="!iftips && params.status==1">
                        *三天內的預約不能取消及更改<br>請直接WhatsApp聯絡店主Cony*
                      </div>
                     </div>
                     <div class="tipsbox" v-if="iftips">
                           <p class="tips">{{tips}}</p>
                           <router-link  to="/user/Booknow"  class="nav" >Check Out Our Services</router-link>
                      </div>
                 </div>
                </div>
          </div>
      </div>
  </div>
</template>

<script>
import { order,orderEel,settings} from '../../api/userMG'


export default {
  name:'Bookings',
  data() {
    return {
      total:0,
      isMobile: false,
      huaimg:require("@/assets/img/hua4.png"),
      ifnow:true,
      path:'',
      iftips:false,
      tips:"You've got nothing booked at the moment.",
      listData:[],
      userdata : JSON.parse(localStorage.getItem('userdata')) ,
      params:{
        status:1,
        program_id:'',
        page:1,
        limit:15,
        client_id:JSON.parse(localStorage.getItem('userdata')).id
      },
      isLoading:true,
      usernav:[
      {
        title:'My Bookings',
        path:'/user/Bookings',

      },
      {
        title:'My Account',
        path:'/user/Index',

      }]
    }
  },
  // 註冊組件
  components: {
   

    
  },
  /**
   * 數據發生改變
   */

  /**
   * 創建完畢
   */
  created() {
    this.getdata(this.params)
    this.getdata2()
  },
  mounted() {
    this.checkDevice();

},
  /**
   * 裏麵的方法隻有被調用才會執行
   */
  methods: {
    handleCurrentChange(val){

      this.params.page=val
      this.getdata(this.params)
    },
    checkDevice() {
      const userAgent = navigator.userAgent;
      this.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
    },
    gowhats(){
   
  
   window.open(this.path, '_blank');
 },
 getdata2() {

  
  

   settings('whatsapp')
     .then(res => {
       this.loading = false

       if (res.data.code != 1) {
         this.$message({
           type: 'info',
           message: res.message
         })
       } else {
           let dd=res.data.data.data
         if(dd.length>0){
           this.path=JSON.parse(dd[0].content)['val']


        
         }
      
          
       }
     })
     .catch(err => {
       this.loading = false
       this.$message.error('菜單加載失敗，請稍後再試！')
     })
 },
    qx(row){

      const now = new Date().getTime();

      let  deadline = new Date(row.time).getTime()
 
if(deadline - now < 259200000){

  this.$message({
              type: 'info',
              message:'三天內預約無法修改，請聯絡店主！'
            })
  return false
}
     



      this.$confirm('確定要刪除嗎?', '信息', {
      confirmButtonText: '確定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {

        orderEel(row)
          .then(res => {
         
            if (res.message=='Cancel successfully') {
              this.$message({
                type: 'success',
                message: '預約已刪除!'
              })
              this.getdata(this.params)
            } else {
              this.$message({
                type: 'info',
                message: res.message
              })
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('預約刪除失敗，請稍後再試！')
          })
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '已取消刪除！'
        })
      })

    },  
    
    sc(status){
         if(status==1){
          this.ifnow=true

         }else{
          this.ifnow=false
         }
         this.listData=[]
         this.params.status=status

         this.getdata(this.params)
    },
    gotos(row){
   

      const now = new Date().getTime();

      let  deadline = new Date(row.time).getTime()
 
if(deadline - now > 259200000){
  this.$router.push({ path: '/user/Booknow', query: { objectParam: JSON.stringify(row) } });
}else{
  this.$message({
              type: 'info',
              message:'三天內預約無法修改，請聯絡店主！'
            })
}
     

    },
    getdata(parameter) {
      this.isLoading = true
    

      order(parameter)
        .then(res => {
          this.isLoading = false
     
          if (res.data.code != 1) {
            this.$message({
              type: 'info',
              message: res.data.message
            })
          } else {

            this.listData = res.data.data.data
           this.total=res.data.data.total
           console.log(this.total)
            if(this.listData.length>0){
              this.iftips=false
            }else{
              this.iftips=true
            }
            if(this.ifnow){
              this.tips="You've got nothing booked at the moment."
            }else{
              this.tips="We’re looking forward to meeting you."
            }
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('菜單加載失敗，請稍後再試！')
        })
    }

   
  }
}
</script>

<style>
  .demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 100%;
  }
</style>
 
 


// WEBPACK FOOTER //
// src/views/user/Bookings.vue